"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toolbar = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../i18n/i18n");
var _StackOrder = require("../../util/StackOrder");
var _ToolbarBase = require("./components/ToolbarBase");
var _FocusContext = require("./context/FocusContext");
var _ToolbarPropsContext = require("./context/ToolbarPropsContext");
var _ToolbarSizeContext = require("./context/ToolbarSizeContext");
var _ToolbarCatalog = require("./i18n/ToolbarCatalog");
const warnOnNoLocaleProp = (0, _lodestarUtils.warnOnce)("Toolbar: The locale prop is currently optional but will be required in a future major " + "version of lodestar-core. Please specify the locale prop. If you do not, it will " + `default to "en" which will probably result in a bug.`);
const Toolbar = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    size = "large",
    isCollapsible = false,
    locale,
    omitButtonGroupSeparators = false,
    renderOn = "canvas",
    ...props
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    if (typeof locale !== "string") {
      warnOnNoLocaleProp();
    }
  }
  (0, _ToolbarCatalog.injectCatalog)();
  const memoizedToolbarSizeContextValue = _react.default.useMemo(() => ({
    toolbarSize: size,
    isCollapsible: isCollapsible
  }), [isCollapsible, size]);
  return (
    /*#__PURE__*/
    // Would love to remove this default locale, but locale isn't a required prop :(
    _react.default.createElement(_StackOrder.StackOrderContextProvider, null, /*#__PURE__*/_react.default.createElement(_i18n.I18nContextProvider, {
      locale: locale || "en"
    }, /*#__PURE__*/_react.default.createElement(_ToolbarSizeContext.ToolbarSizeContext.Provider, {
      value: memoizedToolbarSizeContextValue
    }, /*#__PURE__*/_react.default.createElement(_ToolbarPropsContext.ToolbarPropsContextProvider, {
      renderOn: renderOn,
      omitButtonGroupSeparators: omitButtonGroupSeparators
    }, /*#__PURE__*/_react.default.createElement(_FocusContext.FocusContextProvider, null, /*#__PURE__*/_react.default.createElement(_ToolbarBase.ToolbarBase, (0, _extends2.default)({}, props, {
      size: size,
      ref: ref
    }), children))))))
  );
});
exports.Toolbar = Toolbar;
Toolbar.displayName = "Toolbar";
//# sourceMappingURL=Toolbar.js.map